// extracted by mini-css-extract-plugin
export default {"row":"row_row","isGridRowCellAlignmentEnabled":"row_isGridRowCellAlignmentEnabled"};